import { RiCheckFill } from "react-icons/ri";

const Close = () => (
  <div className="text-[#DF6865] flex flex-col justify-center">
    <div className="w-full bg-[#343030] py-6 px-12">
      <img src="/images/Logo_Lavorix_grande.svg" alt="LogoLavoris" className="h-10" />
      <p className="text-white text-xs">Portal de Clientes</p>
    </div>
    <div className="flex flex-col align-center">
      <RiCheckFill className="text-[#DF6865] mx-auto my-4 h-20 w-20" height="85px" width="85px" />
      <h3 className="text-2xl mx-auto font-bold my-4">Puede cerrar esta página</h3>
    </div>
  </div>
)

export default Close;
